/**
 * Enum for default colors used in c-checkbox
 */
export enum NotificationDefaultColor {
  IconDisabled = 'color-shades-medium1',
  IconEnabled = 'color-blue-dark1',
  TextDisabled = 'color-text-medium1',
  TextEnabled = 'color-blue-dark1'
}
